import { useEffect, useState } from "react";

import { VideosResult, Video, videos, Order } from "../lib/robozinho/videos";

const PAGES_TO_PRELOAD = 2;

export function useVideos(
    channelURL: string
): [
    VideosResult | null,
    Order,
    (newOrder: Order) => void,
    boolean,
    () => void
] {
    const [result, setResult] = useState<VideosResult | null>(null);
    const [order, setOrder] = useState<Order>("new");
    const [page, setPage] = useState(0);

    const [isLoading, setLoading] = useState(false);
    const [cancelPreload, setCancelPreload] = useState(false);

    const [isPreloading, setPreloading] = useState(false);
    const [preloadedData, setPreloadedData] = useState<VideosResult[]>([]);

    async function preload() {
        if (isPreloading) {
            throw new Error("Already preloading");
        }

        setPreloading(true);

        const preloadedDataCopy = [...preloadedData];

        for (let i = 0; i < PAGES_TO_PRELOAD; i++) {
            if (cancelPreload) break;

            if (!preloadedDataCopy[i]) {
                if (!result || page + i < result.pagination.numPages) {
                    preloadedDataCopy[i] = await videos(
                        channelURL,
                        order,
                        page + 1 + i
                    );
                    if (!cancelPreload) {
                        setPreloadedData(preloadedDataCopy);
                    }
                }
            }
        }

        setPreloading(false);
        setCancelPreload(false);
    }

    useEffect(() => {
        setLoading(true);
        videos(channelURL, order, 0).then((videosResult) => {
            setResult(videosResult);
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        if (!isPreloading && preloadedData.length < PAGES_TO_PRELOAD) {
            preload();
        }
    }, [isPreloading, preloadedData]);

    useEffect(() => {
        if (!isPreloading && isLoading && preloadedData[0]) {
            const newResult = preloadedData[0];
            setResult({
                pagination: newResult.pagination,
                channelInfo: newResult.channelInfo,
                videos: [...(result ? result.videos : []), ...newResult.videos],
            });

            setLoading(false);
            setPreloadedData(preloadedData.slice(1));
            setPage(newResult.pagination.currentPage);
        }
    }, [isLoading, isPreloading, preloadedData]);

    const loadMore = () => {
        if (!isLoading && (!result || page + 1 < result.pagination.numPages)) {
            setLoading(true);
        }
    };

    function changeOrder(newOrder: Order) {
        console.log("here");
        if (isLoading) return;

        setLoading(true);
        setOrder(newOrder);

        const tempResult = { ...result, videos: [] } as VideosResult;
        setResult(tempResult);

        setCancelPreload(true);
        setPreloadedData([]);
        setPage(0);

        console.log('here')
        videos(channelURL, newOrder, 0).then((videosResult) => {
            setResult(videosResult);

            setLoading(false);
        });
    }

    return [result, order, changeOrder, isLoading, loadMore];
}
